import axios from "../../axios.js";
const fetchReceivedRatings = ({ commit }, data) => {
    const url = `api/rating/user/${data.user_id}/received?all=true`;

    axios
        .get(url, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            commit("SET_RECEIVED_RATINGS", response.data);
        })
        .catch((err) => {
            console.log(err);
        });
};

const fetchAddedRatings = ({ commit }, data) => {
    const url = `api/rating/user/${data.user_id}/added?all=true`;
    axios
        .get(url, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            commit("SET_ADDED_RATINGS", response.data);
        })
        .catch((err) => {
            console.log(err);
        });
};

export default {
    fetchReceivedRatings,
    fetchAddedRatings
}
